import React from 'react';
import { useRouter } from 'next/router';
import { redirectToLoginPage, useAuth, User } from 'lib/auth';
import { useUser } from 'lib/account';
import { routePaths } from 'appConfig';

import { displayName } from 'lib/utils';
import { Button } from '../Button';
import cn from 'classnames';

const UserMenu = ({ asButton, shadow = true }) => {
  const { session } = useAuth();
  const { user } = useUser(session?.user?.userId);
  const router = useRouter();

  const fullName = displayName({
    firstName: user?.first_name,
    lastName: user?.last_name,
  });

  const redirectUser = () => {
    session ? router.push(routePaths.ACCOUNT) : redirectToLoginPage();
  };

  if (asButton) {
    return (
      <Button
        onClick={redirectUser}
        className={cn(
          'tw-min-w-0 tw-uppercase tw-w-max tw-py-1 md:tw-py-1.5 tw-px-4 md:tw-px-6 tw-text-[1.25rem] md:tw-text-[1.4rem]',
          shadow &&
            'tw-shadow-[0px_3px_6px_rgba(0,0,0,0.16),0px_3px_6px_rgba(0,0,0,0.23)]',
        )}
      >
        Sign In
      </Button>
    );
  }

  return (
    <div className="cart-dropdown">
      <div
        className="wishlist-link"
        style={{ cursor: 'pointer' }}
        onClick={redirectUser}
      >
        <i className="icon-user"></i>
        <span>{fullName}</span>
      </div>

      <div
        className={`dropdown-menu dropdown-menu-right tw-top-[90%] ${
          session ? 'tw-p-4' : ''
        }`}
        style={{ width: 'auto' }}
      >
        <User />
      </div>
    </div>
  );
};

export default UserMenu;
